import { MetaDefinition } from '@angular/platform-browser';
import { getMetaDescriptionTags, getMetaTitleTags } from '../../lib/meta-helpers';

export const simpleMetaResolver = (title: string, description?: string, extraTags: MetaDefinition[] = []) => {
  return {
    title,
    tags: [...getMetaTitleTags(title), ...getMetaDescriptionTags(description), ...extraTags].filter(tag => tag.content),
  };
};
